import { cssVar } from './cssVar'

export const motionEasingTokens = {
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  emphasized: 'cubic-bezier(0.16, 1, 0.3, 1)',
}

export const motionEasingVarTokens = {
  standard: cssVar('--app-motion-ease-standard'),
  emphasized: cssVar('--app-motion-ease-emphasized'),
  outSoft: cssVar('--app-motion-ease-out-soft'),
  outSnappy: cssVar('--app-motion-ease-out-snappy'),
}
